import React from 'react';
import Dashboard from '../../components/admin/dashboard/Dashboard';

const AdminDashboard = () => {
  return <Dashboard />;
};

export default AdminDashboard;